export default {

  ifTrue (key) {
    if (localStorage.getItem(key)) {
      try {
        return JSON.parse(localStorage.getItem(key)) === true
      } catch (e) {
        return false
      }
    }
    return false
  },

  setStringify (key, value) {
    const stringified = JSON.stringify(value)
    localStorage.setItem(key, stringified)
  },

  getParsed (key) {
    if (localStorage.getItem(key)) {
      try {
        return JSON.parse(localStorage.getItem(key))
      } catch (e) {
        return false
      }
    }
    return false
  },

  isLogged () {
    if (localStorage.getItem('session')) {
      try {
        return JSON.parse(localStorage.getItem('session'))
      } catch (e) {
        return false
      }
    } else return false
  }

}
